// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button {
  background: #3bb56e;
  border-color: #3bb56e;
  border-radius: 15%;
  color: white;
  padding: 10px;
  margin: 3px;
}

button:enabled:hover {
  background: #32985c;
  border-color: #2e8f57;
  border-radius: 15%;
  color: white;
  padding: 10px;
  margin: 3px;
}`, "",{"version":3,"sources":["webpack://./src/app/core/controls/button-save/button-save.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,qBAAA;EACM,kBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;AACR;;AAEC;EACC,mBAAA;EACA,qBAAA;EACM,kBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;AACR","sourcesContent":["button {\r\n\t\tbackground: #3bb56e;\r\n\t\tborder-color: #3bb56e;\r\n        border-radius: 15%;\r\n        color: white;\r\n        padding: 10px;\r\n        margin: 3px;\r\n\t}\r\n\r\n\tbutton:enabled:hover {\r\n\t\tbackground: #32985c;\r\n\t\tborder-color: #2e8f57;\r\n        border-radius: 15%;\r\n        color: white;\r\n        padding: 10px;\r\n        margin: 3px;\r\n\t}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
